import React from 'react';
import { X, Plus, Minus, ShoppingBag } from 'lucide-react';
import { useCart } from '../../context/CartContext';
import { useNavigate } from 'react-router-dom';
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '../ui/sheet';
import { Button } from '../ui/button';

const CartDrawer = () => {
  const { cart, isCartOpen, setIsCartOpen, removeFromCart, updateQuantity, cartTotal } = useCart();
  const navigate = useNavigate();

  const handleCheckout = () => {
    setIsCartOpen(false);
    navigate('/checkout');
  };

  return (
    <Sheet open={isCartOpen} onOpenChange={setIsCartOpen}>
      <SheetContent className="w-full sm:max-w-md bg-white flex flex-col">
        <SheetHeader className="border-b pb-4">
          <SheetTitle className="text-lg font-medium tracking-wider">YOUR CART</SheetTitle>
        </SheetHeader>

        {cart.length === 0 ? (
          <div className="flex-1 flex flex-col items-center justify-center text-center py-12">
            <ShoppingBag size={48} className="text-gray-300 mb-4" />
            <p className="text-gray-500">Your cart is empty</p>
            <Button
              onClick={() => {
                setIsCartOpen(false);
                navigate('/products');
              }}
              className="mt-6 bg-[#2d4a47] hover:bg-[#1e3633] text-white rounded-none px-8"
            >
              SHOP NOW
            </Button>
          </div>
        ) : (
          <>
            <div className="flex-1 overflow-y-auto py-4">
              {cart.map((item) => (
                <div key={`${item.productId}-${item.variantId}`} className="flex gap-4 py-4 border-b">
                  <img
                    src={item.image}
                    alt="Natural and organic skincare product"
                    className="w-20 h-20 object-cover"
                  />
                  <div className="flex-1">
                    <h4 className="text-sm font-medium">{item.name}</h4>
                    <p className="text-xs text-gray-500 mt-1">{item.size}</p>
                    <p className="text-sm font-medium mt-1">${item.price.toFixed(2)}</p>
                    <div className="flex items-center gap-3 mt-2">
                      <button
                        onClick={() => updateQuantity(item.productId, item.variantId, item.quantity - 1)}
                        className="w-6 h-6 border border-gray-300 flex items-center justify-center hover:border-[#2d4a47]"
                      >
                        <Minus size={12} />
                      </button>
                      <span className="text-sm">{item.quantity}</span>
                      <button
                        onClick={() => updateQuantity(item.productId, item.variantId, item.quantity + 1)}
                        className="w-6 h-6 border border-gray-300 flex items-center justify-center hover:border-[#2d4a47]"
                      >
                        <Plus size={12} />
                      </button>
                    </div>
                  </div>
                  <button
                    onClick={() => removeFromCart(item.productId, item.variantId)}
                    className="text-gray-400 hover:text-gray-600"
                  >
                    <X size={18} />
                  </button>
                </div>
              ))}
            </div>

            <div className="border-t pt-4 space-y-4">
              <div className="flex justify-between text-sm">
                <span>Subtotal</span>
                <span className="font-medium">${cartTotal.toFixed(2)}</span>
              </div>
              <p className="text-xs text-gray-500">Shipping calculated at checkout</p>
              <Button
                onClick={handleCheckout}
                className="w-full bg-[#2d4a47] hover:bg-[#1e3633] text-white rounded-none py-6 text-sm tracking-wider"
              >
                CHECKOUT
              </Button>
            </div>
          </>
        )}
      </SheetContent>
    </Sheet>
  );
};

export default CartDrawer;
